import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { ExistingSubscriberPortinPage } from './ExistingSubscriberPortinPage';
import { PortInListPage, PortOutListPage, PortinHistoryPage } from './PortLists';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** [route, screen of the reports engine, permission code] of each port-in list. */
const PORT_IN: Array<[path: string, screen: string, code: string]> = [
  ['pending', 'portin-pending', 'PC394'],
  ['manual', 'portin-manual', 'PC394'],
  ['failed', 'portin-failed', 'PC395'],
  ['cancelled', 'portin-cancelled', 'PC395'],
  ['completed', 'portin-completed', 'PC396'],
  ['swaps', 'portin-swaps', 'PC343'],
];
const PORT_OUT: Array<[path: string, screen: string, code: string]> = [
  ['tmobile-completed', 'portout-tmobile-completed', 'PC815'],
  ['itg-pending', 'portout-itg-pending', 'PC923'],
  ['itg-completed', 'portout-itg-completed', 'PC924'],
  ['plum-pending', 'portout-plum-pending', 'PC937'],
  ['plum-completed', 'portout-plum-completed', 'PC936'],
];

/** Ports (PC393): Port In (PC799) and Port Out (PC800). */
export const portsRoutes: RouteObject[] = [
  ...PORT_IN.map(([path, screen, code]) => ({
    path: `ports/in/${path}`,
    // `key` gives each list its own filters and paging.
    element: guard(code, <PortInListPage key={screen} screen={screen} />),
  })),
  {
    path: 'ports/in/existing-subscriber',
    element: guard('PC343', <ExistingSubscriberPortinPage />),
  },
  { path: 'ports/in/history', element: guard('PC778', <PortinHistoryPage />) },
  ...PORT_OUT.map(([path, screen, code]) => ({
    path: `ports/out/${path}`,
    element: guard(code, <PortOutListPage key={screen} screen={screen} />),
  })),
];
